export default __webpack_public_path__ + "static/media/07_zajic_info-min.da7b5cd6.jpg";